import React from 'react';
import './App.css';
import Signup from './Signup';
//import SpotifyLink from './Signup';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h2 id = "App-title">SPOMODORO</h2>
        <Signup id = "signup"/>
        {/*<SpotifyLink /> */}
        
      </header>
    </div>
  );
}

export default App;
